import { render } from "./Forth.vue?vue&type=template&id=71606484&scoped=true"
import script from "./Forth.vue?vue&type=script&lang=js"
export * from "./Forth.vue?vue&type=script&lang=js"

import "./Forth.vue?vue&type=style&index=0&id=71606484&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71606484"]])

export default __exports__